import React from 'react'
import Slider from "react-slick";


const SlidingpanelForLoginAndForgotPassword = () => {

    const settings = {
        infinite: true,
        nav: false,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1
            },
          },
        ],
      };
    
    
    
      const settingslogin = {
        infinite: true,
        nav: false,
        autoplay: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 3000,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              initialSlide: 1
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 1
            },
          },
        ],
      };


  return (
    <div className="col-lg-6 login-slider d-none d-md-block right-side">
    <div className="content-box d-flex flex-column justify-content-center align-items-center h-100">
      <div className="full-width-carousel">
        <Slider {...settings}>
          <div className="slide-img">
            <img src="/images/login/one.png" alt="" />
          </div>
          <div className="slide-img">
            <img src="/images/login/two.png" alt="" />
          </div>
          <div className="slide-img">
            <img src="/images/login/three.png" alt="" />
          </div>
          <div className="slide-img">
            <img src="/images/login/four.png" alt="" />
          </div>
        </Slider>
      </div>
      <div className="content-slide">
        <h1>Expand Your Reach,<br /> Elevate Your Business</h1>
      </div>
      <div className="slider-login1">
        <div className="full-width-carousel">
          <Slider {...settingslogin}>
            <div className="slide-img-vertical">
              <div className="vertical-img">
                <img src="/images/login/slider/dangerous-goods.png" alt="" />
              </div>
            </div>
            <div className="slide-img-vertical">
              <div className="vertical-img">
                <img src="/images/login/slider/express.png" alt="" />
              </div>
            </div>
            <div className="slide-img-vertical">
              <div className="vertical-img">
                <img src="/images/login/slider/global.png" alt="" />
              </div>
            </div>
            <div className="slide-img-vertical">
              <div className="vertical-img">
                <img src="/images/login/slider/nvocc.png" alt="" />
              </div>
            </div>
            <div className="slide-img-vertical">
              <div className="vertical-img">
                <img src="/images/login/slider/personal.png" alt="" />
              </div>
            </div>
            <div className="slide-img-vertical">
              <div className="vertical-img">
                <img src="/images/login/slider/projects.png" alt="" />
              </div>
            </div>
            <div className="slide-img-vertical">
              <div className="vertical-img">
                <img src="/images/login/slider/temp.png" alt="" />
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </div>
  </div>
  )
}

export default SlidingpanelForLoginAndForgotPassword